import { z } from "zod";

export const WEIGHT_MIN_KG = 30;
export const WEIGHT_MAX_KG = 300;

export const UpdateUserProfileSchema = z.object({
  weight: z.preprocess(
    (value) =>
      value === "" || value == null ? null : typeof value === "string" ? Number(value) : value,
    z.number().min(WEIGHT_MIN_KG).max(WEIGHT_MAX_KG).nullable(),
  ),
});

export type UpdateUserProfileRequest = z.infer<typeof UpdateUserProfileSchema>;
